import React from 'react'

import { appCopyContext, hubAppCopyContext } from '../../contexts';
import { AppCopy } from '../../types'
import { Helmet } from 'react-helmet-async'
import {
  resolveContentfulResponse,
} from '../../utils/contentfulUtils'
import { NavigationLayoutPublic } from '../../components'

interface ApplicationLayoutPublicProps {
  children: React.ReactNode
  appCopy: AppCopy
  hubAppCopy: AppCopy
}

// Layout component that wraps all view components.
function ApplicationLayoutPublic({ children, appCopy, hubAppCopy }: ApplicationLayoutPublicProps) {
  // APP COPY - Check if already resolved or needs resolving
  const updatedAppCopy = appCopy?.sys ? resolveContentfulResponse(appCopy)[0] : appCopy

  // HUB APP COPY - Check if already resolved or needs resolving
  const updatedHubAppCopy = hubAppCopy?.sys ? resolveContentfulResponse(hubAppCopy)[0] : hubAppCopy

  return (
    <>
      {/* Set global html lang attribute */}
      <Helmet>
        <html lang="en-US" />
      </Helmet>
      {/* Provide app copy context to app */}
      <hubAppCopyContext.Provider value={updatedHubAppCopy}>
        {/* Provide app copy context to app */}
        <appCopyContext.Provider value={updatedAppCopy}>
          <NavigationLayoutPublic>
            {React.Children.map(children, (child) =>
              React.cloneElement(child, {})
            )}
          </NavigationLayoutPublic>
        </appCopyContext.Provider>
      </hubAppCopyContext.Provider>
    </>
  )
}

export default ApplicationLayoutPublic
